import { useLang } from '@/i18n';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';

let titleSceneC: any = null;
const C = () => {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }

                titleSceneC = AniContainer.create({
                    triggerElement: '.dpu-detail-C .dpu-C-box',
                    triggerHook: 1,
                    offset: '50%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }
            };
        }
    }, []);
    return (
        <section className={`dpu-detail-C dpu-detail-section ${styles.dpuDetailC}`}>
            <div className={`dpu-C-box ${textEnter ? 'enter' : ''}`}>
                <p className='title'>{t('secC_title')}</p>
                <p className='desc'>{t('secC_desc')}</p>
            </div>
        </section>
    );
};

export default C;
